import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResponseTutor, Tutor } from 'src/app/model/Tutor.model';
import { apiService } from 'src/app/service/api.service';
import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { ModalCambiarFotoperfilComponent } from '../jardin/components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';
import { ModalCambiarPassComponent } from '../jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component';

@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: ['./tutor.component.css']
})
export class TutorComponent implements OnInit {

  menuMostrar : string;
  cargando = true;
  tutor:Tutor;
  urlProfile = '';

  constructor(
    private storageService: StorageService,
    private tutorService: TutorService,
    private api: apiService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.menuMostrar = this.storageService.getMenuActivo() != null ? this.storageService.getMenuActivo() : 'inicio' ;
    this.buscaTutor();
    
  }


  getFotoPerfil() {
    this.api.API_POST_obtenerFotoPerfil(this.tutor.idUsuario.toString()).subscribe((response:any) => {
      if(response.payload != null){
        this.urlProfile = "data:image/jpg;base64,"+response.payload;
      }else{
        this.urlProfile = "../../../assets/avatar.png";
      }
      
    },
    (err) => { 
      this.urlProfile = "../../../assets/avatar.png";
      console.log(err)
    })
  }

  buscaTutor(){
    this.tutorService.API_POST_getTutorObjectByIdUsuario(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseTutor) => {
      this.tutor = response.payload; 
      this.getFotoPerfil();
      this.cargando = false; 
    },
    (err) => {
      console.log("error"+err)
      this.cargando = false;
    });
  }


  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    this.menuMostrar = this.storageService.getMenuActivo();
  }


  cambiarPass(){ 
    const dialogRef = this.dialog.open(ModalCambiarPassComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {   
      if(result=='refresh'){
      

      }
    });
  }

  cambiarFoto(){
    const dialogRef = this.dialog.open(ModalCambiarFotoperfilComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }


  cerrarSesion(){
    this.storageService.logout();
  }

}
